import { createSlice } from "@reduxjs/toolkit";
import DefaultBackgroundImage from "../assets/img/main-background.png";
import FaqImage from "../assets/img/faq1.png";
import WarrantyImage from "../assets/img/faq2.png";
import MoreSupportDesktopImage from "../assets/img/support-image.png"
import MoreSupportMobileImage from "../assets/img/support-image-mobile.png"
import RegisterImage from "../assets/img/register-image.png"
import RegisterMobileImage from "../assets/img/register-mobile-image.png"
import ManualsImage from "../assets/img/faq3.png"
import * as urlConfig from "../configs/urlConfig";

const DEFAULT_IMAGE_PATHS = {
    MainImage: DefaultBackgroundImage,
    FaqImage: FaqImage,
    FooterImage: MoreSupportDesktopImage,
    FooterImageMobile: MoreSupportMobileImage,
    WarrantyImage: WarrantyImage,
    RegisterImage: RegisterImage,
    RegisterMobileImage: RegisterMobileImage,
    ManualsImage: ManualsImage,
};

const mergeImagePathsWithDefaults = (apiImagePaths) => {

    return Object.keys(DEFAULT_IMAGE_PATHS).reduce((acc, key) => {
        const apiValue = apiImagePaths?.[key];
        acc[key] = apiValue 
            ? urlConfig.SERVICE_URL + apiValue 
            : DEFAULT_IMAGE_PATHS[key];
        return acc;
    }, {});
};

const contentSlice = createSlice({
    name: 'content',
    initialState: {
        links: {},
        warrantyComponentConf: {}
    },
    reducers: {
        setContentLinks(state, action) {
            const apiImagePaths = action.payload?.data?.imagePaths 
            const processedImagePaths = mergeImagePathsWithDefaults(apiImagePaths);

            state.links = {
                ...(action.payload?.data || action.payload),
                imagePaths: processedImagePaths
            };
        },
        resetContentLinks(state) {
            state.links = {};
        },
        setWarrantyComponentConf(state, action) {
            const payload = action.payload;
            state.warrantyComponentConf = payload.find(config => config.contentTypeName === "WarrantyInformation");
        }
    }
});

export const contentActions = contentSlice.actions;
export default contentSlice;